import React from 'react';
import PropTypes from 'prop-types';
// core components
import GridItem from 'components/UI/Grid/GridItem';
import GridContainer from 'components/UI/Grid/GridContainer';
// our components
import ExchangeRateDetails from 'components/ExchangeRate/Details';

const ScreenExchangeRateDetails = ({ match }) => (
  <GridContainer justify="center">
    <GridItem xs={12} sm={6}>
      <ExchangeRateDetails id={match.params.id} />
    </GridItem>
  </GridContainer>
);

ScreenExchangeRateDetails.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default ScreenExchangeRateDetails;
